import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class FindarrProvider {

  constructor(public http: HttpClient) {
  
  }
  searchmenuteknsii(namaKey:any,dataarr:any){
    if(dataarr != null){
      for(var i=0;i<dataarr.length;i++){
        if(dataarr[i]["kode_karyawan"] === namaKey){
          return dataarr[i];
        }
       }
    }
  }
  searchmenu(namaKey:any,dataarr:any){
    if(dataarr != null){
      for(var i=0;i<dataarr.length;i++){
        if(dataarr[i].business === namaKey){
          return dataarr[i];
        }
       }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/findarr/findarr.ts